import { render, staticRenderFns } from "./PreviousButton.vue?vue&type=template&id=4aeaae6e"
import script from "./PreviousButton.vue?vue&type=script&lang=js"
export * from "./PreviousButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports